import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-lg font-bold text-foreground-950">
                17c<span className="text-accent-500">一起草国</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              优质内容分享平台，致力于为读者提供有价值的阅读体验。涵盖热门推荐、深度解读、精品原创、教程指南等多个领域。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">更多分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系方式</h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-500" />
                <span>contact@17cyqc.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-500" />
                <span>400-888-0000</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-500" />
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 17c一起草国. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}